// @flow
import React from "react";
import {
	Box,
	Grid, List,
	ListItem,
	Stack,
	Typography,
	Button
} from "@mui/material";
import moment from "moment";
import { useHistory, Link } from "react-router-dom";
import { getRouteUrl } from "../../../../helpers/getRouteUrl";
import { ROUTE_PAGE_LOANS_DETAILS } from "../../routes/routes";
import { ROUTE_LOAN_APPLICATION } from "../../../loanApplication/routes/routes";
import PermissionHOC from "../../../permission/components/permissionHOC/permissionHOC";
import { useTranslation } from "react-i18next";
import { LOANS } from "../../locales/namespaces";
import MainCard from "../../../../theme/mantis/components/mainCard";
import { textTranslate } from "../../../../helpers/helpers";
import useUserData from "../../../../hooks/user/useUserData";
import { NumericFormat } from "react-number-format";
import Euro from "../../../../assets/images/icons/euro";
import ShowIcon from "../../../../assets/images/icons/buttonsIcons/showIcon";
import AccordionDots from "../../../../assets/images/icons/accordionDots";
import Edit from "../../../../assets/images/icons/loan/edit";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import alphaLogo from '../../../../assets/images/banks/alphabank.jpg';
import ethnikiLogo from '../../../../assets/images/banks/ethniki.jpg';
import eurobankLogo from '../../../../assets/images/banks/eurobank.jpg';
import optimaLogo from '../../../../assets/images/banks/optima.jpg';
import piraeusLogo from '../../../../assets/images/banks/piraeus.jpg';
import atticabankLogo from '../../../../assets/images/banks/atticabank.png';
import pendingBank from '../../../../assets/images/banks/bank-image-pending.png';

const IndexListLoans = ({ data }) => {
	const { t } = useTranslation(LOANS)
	const { language, thousandSeparator, decimalSeparator } = useUserData()
	const history = useHistory()


	const bankLogos = {
		alphabank: alphaLogo,
		ethniki: ethnikiLogo,
		eurobank: eurobankLogo,
		optima: optimaLogo,
		piraeus: piraeusLogo,
		attica: atticabankLogo,
	};

	const getBankLogoKey = (bankId) => {
		switch (bankId) {
			case '1':
				return 'ethniki';  
			case '2':
				return 'eurobank'; 
			case '3':
				return 'alphabank';
			case '4':
				return 'piraeus';
			case '5':
				return 'optima';
			case '6':
				return 'attica';
			default:
				return null;
		}
	};


	return (
		<Box sx={{ mb: 2 }}>
			<PermissionHOC requiredPermissions={['access_loan_index_list']}>
				<Grid container spacing={2}>
					{data.map((item, index) => (
						<Grid item xs={12} sm={6} md={6} lg={6} key={index} >

							<Box sx={{ backgroundColor: 'white', borderRadius: '8px' }}>
								<MainCard sx={{
									boxShadow: '0px 1px 9px 0px #CAD1E5',
									mt:{
										xs:'0',
										sm:'16px',
										md:'16px',
									},
									padding: '0 !important',
									'& .MuiCardContent-root':{
										padding: {
											xs:'16px',
											sm:'16px',
											md:'20px',

										}
									}
								}}>

									<Stack sx={{ backgroundColor: '#F5F7FC', padding: '10px', borderRadius: '8px', lineHeight: '0', width: 'fit-content' }}>
										<Euro />
									</Stack>


									<Stack direction="row"
										sx={{ width: 'fit-content', marginTop: '20px' }}
										className="flex-center"
										spacing={3}>
										<Typography className="color-secondary p-xsfs">
											{ item.ApprovedAmount ? t('Approved amount (€)') : t('Loan amount (€)') }
										</Typography>
										<NumericFormat
											className="color-default title-xsm"
											thousandSeparator={thousandSeparator}
											decimalSeparator={decimalSeparator}
											displayType="text"
											value={item.ApprovedAmount ? item.ApprovedAmount : (item.RequestedAmount ? item.RequestedAmount : '-')}
										/>
									</Stack>


									<Box sx={{ borderTop: '0.6px solid #DAE0F0', marginTop: '20px' }}></Box>


									<Stack
										sx={{ width: 'fit-content', margin: '10px 0 10px 0' }}
										direction="row"
										className="flex-center"
										spacing={3}>
										<Typography className="color-secondary p-xsfs">
											{t('Bank')}
										</Typography>
										<Typography className="color-default title-xsm flex-center" style={{minHeight:'60px'}}>
											{(() => {
												const logoKey = getBankLogoKey(item.BankId);
												const logoSrc = bankLogos[logoKey];

												return logoSrc ? (
													<img
														src={logoSrc}
														alt={(item.BankId || '')}
														style={{ width: '128px', margin: '0 auto' }}
													/>
												) : (
													<span>
														<img src={pendingBank} alt='pendingBank' style={{ width: '128px', margin: '0 auto' }}/>
													</span>
												);
											})()}
										</Typography>
									</Stack>


									<Box sx={{ borderTop: '0.6px solid #DAE0F0', marginBottom: '20px' }}></Box>


									<Stack spacing={0.5}>
										<Typography
											className="color-secondary p-xsfs"
										>
											{t('Loan status')}
										</Typography>
										<Typography className="p-sm color-default">
											{textTranslate(language)({
												en: item.StatusEn,
												el: item.StatusEl
											})}
										</Typography>
									</Stack>

								</MainCard>
								<Box>
									<Accordion sx={{
										backgroundColor: 'transparent',
										border: 'none',
										boxShadow:'-4px 0px 6px -4px #CAD1E5,4px 0px 6px -4px #CAD1E5',
										'.MuiAccordionSummary-root': {
											background: 'transparent'
										},
										'&.Mui-expanded': {
											margin: '0 !important',
										},
									}}>
										<AccordionSummary expandIcon={<AccordionDots />} sx={{
											flexDirection: 'row',
											'& .MuiAccordionSummary-expandIconWrapper': {
												transform: 'rotate(0deg) !important',
												transition: 'none !important',
												backgroundColor: 'white !important',
												border: '0.6px solid #DAE0F0 !important',
											},
											'&.Mui-expanded .MuiAccordionSummary-expandIconWrapper': {
												transform: 'rotate(0deg) !important',
											},
										}}>
											<Typography className="color-default p-xs">
												{t('Loan Information')}
											</Typography>
										</AccordionSummary>


										<AccordionDetails sx={{ border: 'none', paddingTop:'0' }}>

											<Grid container spacing={2}>
												<Grid item xs={12} sm={6} md={6} lg={6}>



													<Box sx={{paddingTop:'10px'}}>
														<Typography className="color-secondary p-xsfs">
															{t('Created')}
														</Typography>
														<Typography className="color-default p-sm">
															{moment(item.CreatedAt).format("DD-MM-YYYY")}
														</Typography>
													</Box>
												</Grid>
												<Grid item xs={12} sm={6} md={6} lg={6}>
													<Box sx={{paddingTop:'10px'}}>
														<Typography className="color-secondary p-xsfs">
															{t('Loan Purpose')}
														</Typography>
														<Typography className="color-default p-sm">
															{textTranslate(language)({
																en: item.TypeEn,
																el: item.TypeEl
															})}
														</Typography>
													</Box>
												</Grid>

												<Grid item xs={12} sm={6} md={6} lg={6}>
													<Box sx={{paddingTop:'10px'}}>
														<Typography className="color-secondary p-xsfs">
															{t('Property Commercial Value (€)')}
														</Typography>
														<Typography className="color-default p-sm">
															<NumericFormat
																thousandSeparator={thousandSeparator}
																decimalSeparator={decimalSeparator}
																displayType="text"
																value={ item.RealEstateValue }
															/>
														</Typography>
													</Box>
												</Grid>


												<Grid item xs={12} sm={6} md={6} lg={6}>
													<Box sx={{paddingTop:'10px'}}>
														<Typography className="color-secondary p-xsfs">
															{t('Loan Duration')}
														</Typography>
														<Typography className="color-default p-sm">
															{ item.Duration ? item.Duration  : '-'}
														</Typography> 
													</Box>
												</Grid>


												<Grid item xs={12} sm={6} md={6} lg={6}>
													<Box sx={{paddingTop:'10px'}}>
														<Typography className="color-secondary p-xsfs">
															{t('Fixed Interest Rate Duration')}
														</Typography>
														<Typography className="color-default p-sm">
															{item.FixedDuration ? item.FixedDuration : '-'}
														</Typography> 
													</Box>
												</Grid>


												<Grid item xs={12} sm={6} md={6} lg={6}>
													<Box sx={{paddingTop:'10px'}}>
														<Typography className="color-secondary p-xsfs">
															{t('Number of Borrowers')}
														</Typography>
														<Typography className="color-default p-sm">
															{item.CoborrowerNo ? item.CoborrowerNo : '-'}
														</Typography>
													</Box> 
												</Grid>

												<Grid item xs={12} sm={6} md={6} lg={6}>
													<Box sx={{paddingTop:'10px'}}>
														<Typography className="color-secondary p-xsfs">
															{t('Number of Guarantors')}
														</Typography>
														<Typography className="color-default p-sm">
															{item.GuarantorNo ? item.GuarantorNo : '-'}
														</Typography>
													</Box>
												</Grid>


											</Grid>


										</AccordionDetails>
									</Accordion>
									
									{item?.AccessApp === '1' && (
										<Box sx={{
											padding: {
												xs:'0 16px',
												sm:'0 16px',
												md:'0 20px',
											},
											backgroundColor: '#fff',
											boxShadow: '-4px 0px 6px -4px #CAD1E5, 4px 0px 6px -4px #CAD1E5',
										}}>
											<Box
												sx={{
													padding: '20px',
													borderTop: '0.6px solid #DAE0F0',
													borderBottom: '0.6px solid #DAE0F0',
													backgroundColor: 'transparent'
												}}
											>
												<Grid container justifyContent="center">
													<Grid item>
														<Button
															size="medium"
															variant="contained"
															color="info"
															component={Link}
															to={getRouteUrl(ROUTE_LOAN_APPLICATION, { id: item?.id })}
															sx={{
																'& svg': {
																	mr: 1,
																},
															}}
															>
																<Edit />
																{t('Application Details Completion')}
														</Button>
													</Grid>
												</Grid>
											</Box>
										</Box>
										)}
									<Typography className="flex-center color-btn-view btn-secondary p-xs"
										sx={{
											boxShadow: item?.AccessApp === '1'
												? '-4px 4px 6px -4px #CAD1E5, 4px 4px 6px -4px #CAD1E5, 0px 4px 6px -4px #CAD1E5'
												: '0px 1px 9px 0px #CAD1E5',
											borderRadius: '0 0 8px 8px',
											padding: '20px 0',
											cursor:'pointer',
											'& svg': {
												width: '18px',
												marginRight: '8px',
											},
											'& svg g': {
												stroke: '#0BC1B6',
											}
										}}
										onClick={() => history.push(getRouteUrl(ROUTE_PAGE_LOANS_DETAILS, { id: item.id }))}
									>
										<ShowIcon sx={{ 'g': { stroke: '#0BC1B6' } }} />{t('View')}
									</Typography>

								</Box>
							</Box>





						</Grid>
					))}
				</Grid>

			</PermissionHOC>
		</Box >
	)
}

export default IndexListLoans